"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.content = exports.quantity = exports.price = exports.bar = exports.barContainer = exports.row = exports.header = exports.label = exports.container = void 0;

var _util = require("../../../util");

const container = () => ({
  width: '50%'
});

exports.container = container;

const label = ({
  theme,
  cssProps
}) => ({
  padding: cssProps.collapsed ? 0 : (0, _util.spacing)(theme, [0, 'xxsmall'])
});

exports.label = label;

const header = ({
  cssProps,
  theme
}) => {
  const {
    side,
    collapsed
  } = cssProps;
  const isBid = side === 'bid';
  const padding = collapsed ? 16 : 40;
  return {
    height: 32,
    marginBottom: 8,
    paddingRight: isBid ? padding : 0,
    paddingLeft: isBid ? 0 : padding,
    boxShadow: collapsed ? (0, _util.boxShadow)(theme, [0, -1, 0, 0, 'ui3', true]) : 'none'
  };
};

exports.header = header;

const row = ({
  theme
}) => ({
  height: 32,
  position: 'relative',
  width: '100%',
  zIndex: 0,
  '&:before': {
    content: "''",
    borderRadius: 2,
    height: '100%',
    left: -4,
    position: 'absolute',
    top: 0,
    transition: 'background .2s ease',
    width: 'calc(100% + 8px)',
    zIndex: -1
  },
  '&:hover:before': {
    background: (0, _util.color)(theme, 'interactive.ui.hover')
  },
  '&:active:before': {
    background: (0, _util.color)(theme, 'interactive.ui.active')
  }
});

exports.row = row;

const barContainer = () => ({
  flexGrow: 1,
  height: 24
});

exports.barContainer = barContainer;

const bar = ({
  cssProps,
  theme
}) => {
  const {
    side,
    width
  } = cssProps;
  const isBid = side === 'bid';
  return {
    backgroundColor: (0, _util.color)(theme, isBid ? 'data.positiveSubtle' : 'data.negativeSubtle'),
    width: "".concat(width, "%"),
    borderRadius: 2
  };
};

exports.bar = bar;

const price = ({
  cssProps,
  theme
}) => {
  const {
    side
  } = cssProps;
  const isBid = side === 'bid';
  return {
    position: 'absolute',
    padding: (0, _util.spacing)(theme, [0, 'xxsmall']),
    right: isBid ? 0 : 'initial',
    left: isBid ? 'initial' : 0
  };
};

exports.price = price;

const quantity = ({
  cssProps,
  theme
}) => {
  const {
    side,
    collapsed
  } = cssProps;
  const isBid = side === 'bid';
  return {
    width: 56,
    textAlign: isBid ? 'left' : 'right',
    padding: (0, _util.spacing)(theme, [0, 'xxsmall']),
    position: collapsed ? 'absolute' : 'initial',
    left: isBid ? 0 : 'initial',
    right: isBid ? 'initial' : 0
  };
};

exports.quantity = quantity;

const content = ({
  cssProps,
  theme
}) => {
  const {
    side,
    collapsed
  } = cssProps;
  const isBid = side === 'bid';
  const padding = collapsed ? 16 : 40;
  return {
    boxShadow: isBid && !collapsed ? (0, _util.boxShadow)(theme, [-1, 0, 0, 0, 'ui3', true]) : 'none',
    width: '100%',
    paddingRight: isBid ? padding : 0,
    paddingLeft: isBid ? 0 : padding
  };
};

exports.content = content;
//# sourceMappingURL=HorizontalBarChart.style.js.map